import {Component, Input, OnChanges, SimpleChanges} from "@angular/core";
import {
    AiAppEventRendererComponent
} from "../../../../../../../modules/ai/realtime/api/component/aiAppEventRenderer.component";
import {AiRealtimeAppEvent} from "../../../../../../../modules/ai/realtime/api/service/aiRealtime.service";
import {
    MedicalMorphologyConverter
} from "../../../../../../../modules/medical/morphology/api/model/converter/medicalMorphology.converter";
import {
    MedicalMorphologyModel
} from "../../../../../../../modules/medical/morphology/api/model/medicalMorphology.model";
import {
    ConsultationMorphologyItemComponent
} from "../consultation-morphology-item/consultation-morphology-item.component";

@Component({
    selector: 'app-morphology-ai-event',
    standalone: true,
    imports: [ConsultationMorphologyItemComponent],
    template: `
    <app-luna-consultation-morphology-item
      [displayDate]="false"
      [morphology]="morphology">
    </app-luna-consultation-morphology-item>
  `,
})
export class ConsultationMorphologyAiEventComponent implements AiAppEventRendererComponent, OnChanges {
    static readonly eventName = 'medicalMorphology';
    morphology: MedicalMorphologyModel;

    @Input() event!: AiRealtimeAppEvent;

    constructor(private morphologyConverter: MedicalMorphologyConverter) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.morphology = this.morphologyConverter.convert(this.event?.data);
    }
}
